<div class="content">
    <div class="d-flex justify-content-start mt-2">

        <div (click)="goToTariffView()" style="cursor: pointer;">
            <div class="d-flex align-items-center">
                <i class="fa-solid fa-arrow-left"></i>
                <span>Back to tariffs</span>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <h2>Product Offering</h2>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <ng2-smart-table [settings]="settingsFilter" [source]="listTariff">
        </ng2-smart-table>


    </div>

    <div class="d-flex justify-content-center mt-4">
        <h2>Bundled Product Offering</h2>
    </div>

    <div class="d-flex justify-content-center mt-4">
        <ng2-smart-table [settings]="settings" [source]="listTariffBundled">
        </ng2-smart-table>


    </div>

</div>